import {
  LayoutDashboard,
  FolderOpen,
  Receipt,
  FileText,
  UserCog,
  BookOpen,
  Bed,
  FileBox,
  Send,
  Package,
  Shield,
  Sparkles,
  MessageCircle,
  CalendarDays,
  NotebookPen,
  ClipboardCheck,
  Users,
  Mail,
  Share2,
  HeartPulse,
  UserSearch,
  Wrench,
  Building,
} from "lucide-react";

/** Id mese corrente per banner novità: aggiornare quando si apre un nuovo mese in RELEASE_NOTES. */
export const CURRENT_RELEASE_MONTH_ID = "2026-10";

const OCTOBER_2026_SECTIONS = [
  {
    id: "fascicolo-cambio-rinnovo-medico",
    title: "Fascicoli — Cambio e rinnovo medico",
    icon: HeartPulse,
    items: [
      "Nel tab Sanitaria il modulo di cambio o rinnovo medico si compila con i dati dell'ospite, del documento e del medico",
      "Si invia al medico insieme alle copie dei documenti di identità già nel fascicolo",
      "La scadenza del riscontro compare negli avvisi del fascicolo e in dashboard finché la richiesta è aperta",
    ],
  },
  {
    id: "admin-strutture-catalogo-cdrpt",
    title: "Admin — Strutture sull'app CasaDiRiposoPerTe",
    icon: Building,
    items: [
      "In Admin → Strutture si inserisce una struttura senza creare prima un utente",
      "L'interruttore Su CasaDiRiposoPerTe mostra o nasconde quella struttura sull'app di prenotazione",
    ],
  },
  {
    id: "commerciale-visite-strutture",
    title: "Commerciale — Le mie visite",
    icon: CalendarDays,
    items: [
      "Nuovo percorso da tablet per visite alle strutture: bozza recuperabile, intervista, servizi di interesse, note, esito e prossimo appuntamento",
      "Le visite riusano anagrafica strutture, pipeline Affidya e attività: una visita può collegare un prospect esistente o creare un’opportunità dalla stessa anagrafica",
      "Il follow-up della visita genera un promemoria nell’Admin e via email al responsabile; la visibilità rispetta assegnazioni e permessi commerciali",
      "PWA installabile da /visite-login e app native Android e iOS (it.affidya.visite) per Le mie visite: stesso accesso Admin, solo l’area visite",
    ],
  },
  {
    id: "sanitario-senza-vera",
    title: "Sanità Rapida",
    icon: HeartPulse,
    items: [
      "Rimosso il collegamento esterno Vera – AI Medica da menu, home e impostazioni",
      "PWA installabile e app native Android e iOS (it.affidya.sanitario) per Sanità Rapida, pensate per il tablet: accesso da /sanitario-login, orientamento libero e pagina a tutta larghezza da 600 dp",
    ],
  },
  {
    id: "marketing-social-admin",
    title: "Commerciale — Marketing e Social",
    icon: Share2,
    items: [
      "Nuovo spazio Admin per configurare fonti dell’Osservatorio, preparare e approvare contenuti, pianificare il calendario e gestire profili, asset, link, form e integrazioni",
      "Le integrazioni reali richiedono configurazione per marchio; la modalità Sandbox permette di provare pubblicazione e metriche senza inviare contenuti a provider esterni",
      "Dashboard e report include la vista Marketing e Social con filtri e riepilogo dei risultati per canale; un clic WhatsApp resta un clic e non viene contato come lead",
    ],
  },
  {
    id: "cdrpt-partnership-strutture",
    title: "CasaDiRiposoPerTe — Partnership strutture",
    icon: Users,
    items: [
      "Nuovo percorso commerciale Partnership strutture, separato da Richieste famiglie e dalla Pipeline Affidya, con viste Elenco e Pipeline, responsabili, attività, storico, accordi e attivazione",
      "Rete CDRPT e abbonamento portale sono indipendenti: Basic €9,99/mese e Premium €19,99/mese IVA inclusa non bloccano l’attivazione della partnership o la ricezione dei lead",
      "Le commissioni sono congelate al momento dell’ingresso effettivo: partner storiche €700 + IVA in due rate, nuove partnership 50% della retta concordata IVA inclusa in due rate uguali",
    ],
  },
  {
    id: "commerciale-pipeline-cdrpt",
    title: "Commerciale — Pipeline CDRPT",
    icon: Users,
    items: [
      "Richieste famiglie ora offre Elenco e Pipeline sulla stessa pratica, con filtri Tutte, Le mie pratiche e Non assegnate",
      "Responsabile, primo contatto, ricontatti, esiti delle strutture e ingresso programmato o effettivo si gestiscono dalla scheda pratica",
      "L’ingresso effettivo programma le due rate dalla condizione commerciale congelata; emissioni e pagamenti restano vuoti finché non vengono registrati",
    ],
  },
  {
    id: "commerciale-ospiti-rete-tab",
    title: "Commerciale — Ospiti in Rete",
    icon: Users,
    items: [
      "In Richieste famiglie c’è il tab dedicato «Ospiti in Rete», separato da Nuovo/Contattato/ecc.",
      "Si vede quale struttura ha condiviso la pratica; la data di inserimento è la data di condivisione",
      "Il commerciale può aggiornare stato gettone e pagamento dal dettaglio del lead",
    ],
  },
  {
    id: "commerciale-whatsapp-posti",
    title: "Commerciale — WhatsApp",
    icon: MessageCircle,
    items: [
      "Risposte rapide al template posti: SI (donna/uomo) aggiunge +1 posto in scheda struttura, «nessuna disponibilità» imposta 0",
      "Le risposte scritte a mano restano in Da confermare per controllo operatore",
    ],
  },
  {
    id: "fascicoli-contabile-coordinatore",
    title: "Fascicoli e permessi",
    icon: Shield,
    items: [
      "Il Coordinatore non vede più di default retta, tariffe, deposito e sezioni fatturazione ospite nel fascicolo",
      "Il responsabile può abilitare la visione dati contabili per singolo utente (permesso «Visualizza dati contabili fascicolo» in Impostazioni → Utenti)",
    ],
  },
];

export const RELEASE_NOTES_SEEN_KEY = "affidya_release_notes_seen";

export const RELEASE_META = {
  title: "Novità aggiornamenti",
  subtitle: "Aggiornamenti e miglioramenti della piattaforma",
  intro:
    "Di seguito le principali novità e miglioramenti introdotti nel sistema, raggruppati per mese e area funzionale.",
};

const MAY_2026_SECTIONS = [
  {
    id: "dashboard",
    title: "Dashboard e panoramica",
    icon: LayoutDashboard,
    items: [
      "Personalizzazione dashboard: scegliere card, disposizione e vista compatta o dettagliata",
      "Nuove card con metriche avanzate, calendario compleanni e barra azioni rapide",
      "Diario consegne accessibile dalla dashboard con card dedicata",
      "Vista multi-struttura con pannello di controllo aggregato",
      "Widget di assistenza per richiedere supporto dall'interfaccia",
      "Supporto per account dimostrativi",
    ],
  },
  {
    id: "fascicoli",
    title: "Fascicoli assistenziali e PAI",
    icon: FolderOpen,
    items: [
      "Nuova gestione firma contratto con blocco automatico se mancano dati obbligatori",
      "Firma per delega dell'autorizzazione medica",
      "Supporto ospiti in regime diurno",
      "Campi firma sulla stampa del PAI",
      "Caricamento PAI direttamente dal fascicolo",
      "Generazione PDF con i dati di emergenza dell'ospite",
      "Fascicolo 118 migliorato con gestione documento di identità",
    ],
  },
  {
    id: "fatturazione",
    title: "Fatturazione",
    icon: Receipt,
    items: [
      "Anteprima fattura e gestione deposito cauzionale",
      "Solleciti di pagamento con generazione PDF",
      "Esclusione spese prima nota dalla fatturazione",
      "Fatture passive: visualizzazione comoda in PDF",
      "Invio automatico delle fatture via email",
      "Correzioni per voci esenti IVA e codici fiscali",
    ],
  },
  {
    id: "alloggiati",
    title: "Alloggiati Web",
    icon: FileText,
    items: [
      "Messaggi di errore più chiari con suggerimenti correttivi",
      "Validazione preventiva codici comune di nascita e luogo di rilascio",
      "Tracciamento invii con esito di ogni schedina",
      "Campi sesso e camera nelle richieste di inserimento ospite",
      "Date di arrivo registrate con fuso orario locale (Italia)",
    ],
  },
  {
    id: "turni",
    title: "Turni e personale OSS",
    icon: UserCog,
    items: [
      "Turni OSS suddivisi in mattina, pomeriggio e notte",
      "Svuotamento rapido assegnazioni di un mese o di una riga OSS",
      "Assegnazione OSS direttamente dalla pagina Camere",
      "Gestione ferie OSS con integrazione nella pianificazione turni",
      "Grafica turni migliorata nell'area OSS",
    ],
  },
  {
    id: "diario",
    title: "Diario consegne",
    icon: BookOpen,
    items: [
      "Nuova pagina dedicata al diario consegne",
      "Dettatura vocale delle note (area amministrativa e area OSS)",
    ],
  },
  {
    id: "ospiti",
    title: "Ospiti e camere",
    icon: Bed,
    items: [
      "Flag per identificare gli ospiti residenti",
      "Richieste ospiti con foto profilo, data di nascita e piano camera",
      "Registrazione bonifici e promemoria automatici",
      "Gestione terapie aggiuntive non incluse nel piano standard",
      "Inserimento manuale misurazioni pressione arteriosa",
    ],
  },
  {
    id: "documenti",
    title: "Documenti",
    icon: FileBox,
    items: [
      "Modulo Documenti riorganizzato in 4 tab: Struttura, Stampe Mensili, Moduli da Firmare, Biblioteca Affidya",
      "Stampe mensili: HACCP, schema alvo, schema docce, fogli firma e registri personalizzati con wizard di generazione",
      "Moduli da firmare: invio ai familiari con link sicuro, firma digitale e archivio automatico nel fascicolo",
      "Biblioteca Affidya: catalogo normative e modelli curato dal team Affidya",
      "Card uniformi con altezza fissa e footer ancorato in tutte le sezioni",
    ],
  },
  {
    id: "comunicazioni",
    title: "Comunicazioni",
    icon: Send,
    items: [
      "Invio email ai contatti familiari dal sistema",
      "Programmazione invio comunicazioni in data e ora future",
    ],
  },
  {
    id: "deblistering",
    title: "Deblistering",
    icon: Package,
    items: [
      "Accesso al modulo per tutti gli utenti autenticati",
      "Etichette schede, logo e dati medici aggiornati",
    ],
  },
  {
    id: "accesso",
    title: "Accesso e sicurezza",
    icon: Shield,
    items: [
      "Accesso con account Google",
      "Accesso rapido e sicuro con impronta o riconoscimento facciale",
      "Pannello amministratore per la gestione permessi utente",
    ],
  },
  {
    id: "interfaccia",
    title: "Interfaccia e terminologia",
    icon: Sparkles,
    items: [
      "Rinominata voce \"Posti liberi\" in \"Camere e posti letto\"",
      "Colori e stili card dashboard, immagini hero dinamiche e grafici aggiornati",
    ],
  },
];

const JUNE_2026_SECTIONS = [
  {
    id: "assistente",
    title: "Assistente virtuale",
    icon: MessageCircle,
    items: [
      "Chatbot integrato per orientamento e operazioni nel gestionale",
      "Supporto multi-struttura: risposte e azioni nel contesto della struttura selezionata",
      "Azioni rapide e suggerimenti cliccabili all'apertura della chat",
      "Consultazione stato Deblistering, fatture, pratiche e invii email con conferma utente",
    ],
  },
  {
    id: "centro-diurno",
    title: "Centro Diurno",
    icon: CalendarDays,
    items: [
      "Nuovo modulo opzionale da attivare su richiesta presso Affidya",
      "Dashboard, agenda e prenotazioni per le attività giornaliere",
      "Registro presenze giornaliere degli ospiti diurni",
      "Pianificazione trasporti e pulmino, con portale dedicato per l'autista",
      "Gestione mezzi, autisti, pacchetti servizi e reportistica dedicata",
    ],
  },
  {
    id: "ricette-farmacia",
    title: "Deblistering — Ricette e Terapie",
    icon: Package,
    items: [
      "Flusso Ricette: richieste farmacia, ricette da medico e gestione medici curanti",
      "Nuovo tab Terapie Deblistering: gestione terapie per ogni ospite con stati a colore (sincronizzata, da validare, anomalia)",
      "Analisi automatica terapia: lettura del documento con confronto tra situazione attuale e proposta per ogni modifica",
      "Approvazione e sincronizzazione terapie: approva singola o più terapie insieme, con aggiornamento automatico nel fascicolo assistenziale",
      "Link sicuro per invio terapia: invia link a medico o familiare per caricare il documento direttamente",
      "Caricamento terapia tramite link sicuro, senza account",
      "Cronologia eventi per ogni pratica farmacia: storico azioni con autore e timestamp",
      "Filtri per farmacia, stato e periodo nelle richieste farmacia con esportazione dell'elenco",
      "Filtri per stato e periodo nelle ricette da medico con esportazione dell'elenco",
      "Invio automatico al medico: se abilitato in Impostazioni Ricette, dopo l'analisi di una richiesta farmacia la comunicazione viene inviata automaticamente al medico curante dell'ospite",
      "Modifica proposta terapia: prima di approvare è possibile correggere farmaco, dosaggio, frequenza e note direttamente dal tab Da validare",
      "Log eventi automatici: modifiche manuali e eliminazioni terapie vengono tracciate nella cronologia pratica",
      "Indicatori panoramica aggiornati: «ricette pronte per farmacia» e «pratiche in attesa medico» ora mostrati in tempo reale",
      "Stato terapia degli ospiti visibile anche nel tab Ricette da medico",
      "Canale notifiche (email, in-app, entrambi) salvato nelle impostazioni Ricette",
      "Tracking email invio ricette alla farmacia: indicatori Inviata, Consegnata e Aperta in tabella e dettaglio, con eventi in Panoramica e notifica in-app",
      "Inoltro comunicazioni con dialog email e stampa thread formattata",
      "Classificazione email migliorata: le email senza allegati vengono archiviate in Comunicazioni generali",
      "Classificazione email farmacia corretta: oggetti tipo «Richiesta ricette…» e mittente farmacia vanno in Richieste farmacia, non in Ricette da medico",
      "Nuovo tab Confronto: vista unificata per ospite (richieste vs ricette) con azione Sposta per correggere classificazione errata",
      "Fix triplicazione richieste farmacia da email: idempotenza webhook e una sola richiesta per ospite (allegati uniti)",
      "Panoramica Ricette: flag Invio richieste al medico (anche segnatura manuale/WhatsApp), popup resoconto pratica con confronto farmaci e archiviazione",
    ],
  },
  {
    id: "fascicoli-giu",
    title: "Fascicoli assistenziali e PAI",
    icon: FolderOpen,
    items: [
      "Gestione uscita temporanea degli ospiti",
      "Proroga valutazione PAI",
      "Firma digitale PAI a fine compilazione (touch e tavoletta Wacom STU)",
      "Indirizzo strutturato su cartella clinica e fascicolo",
      "Comunicazioni con medici professionisti",
      "Stampa delle terapie attive",
    ],
  },
  {
    id: "fatturazione-giu",
    title: "Fatturazione",
    icon: Receipt,
    items: [
      "Note di credito",
      "Destinatario fatturazione dedicato per ospite",
      "Impostazioni quota mensile",
      "Collegamento al servizio di fatturazione elettronica: import anagrafiche clienti e gestione fatture",
      "Aggiornamento automatico dello stato di invio delle fatture e approvazione automatica",
      "Anteprima fattura con codice QR",
      "Recupero collegamento Fatture in Cloud: ricerca approfondita e collegamento fatture Affidya già approvate al documento esistente su FIC (errore numerazione duplicata)",
      "Controllo mensile: invio approvate a SDI in background con coda, pausa tra gli invii, stato In coda SDI e aggiornamento automatico della lista",
    ],
  },
  {
    id: "diario-personale",
    title: "Diario Personale",
    icon: NotebookPen,
    items: [
      "Nuova pagina dedicata alle note interne della struttura",
      "Registro separato dal diario consegne, accessibile dal menu Gestione",
    ],
  },
  {
    id: "pre-ingresso",
    title: "Pre-ingresso",
    icon: ClipboardCheck,
    items: [
      "Portale esterno per la raccolta documenti prima dell'ammissione",
      "Richiesta documenti alle famiglie con tracciamento avanzamento",
      "Gestione requisiti terapie nel flusso di pre-ingresso",
    ],
  },
  {
    id: "ospiti-oss-giu",
    title: "Ospiti, camere e area OSS",
    icon: Bed,
    items: [
      "Trasferimento ospiti tra strutture e ricerca globale migliorata",
      "Alert terapie del giorno nell'area OSS",
      "Autenticazione OSS con dispositivo registrato",
      "Monitoraggio manuale glicemia e saturazione ossigeno",
    ],
  },
  {
    id: "alloggiati-giu",
    title: "Alloggiati Web",
    icon: FileText,
    items: [
      "Vista panoramica invii e stato delle schedine",
      "Metriche finanziarie aggiornate in dashboard per la struttura corrente",
    ],
  },
  {
    id: "accesso-giu",
    title: "Accesso e documenti legali",
    icon: Shield,
    items: [
      "Accettazione termini di servizio e documenti legali in fase di accesso",
      "Pagine Privacy, Cookie e Termini di servizio aggiornate",
    ],
  },
];

const JUNE_2026_OSPITI_RETE_SECTIONS = [
  {
    id: "ospiti-rete-v2",
    title: "Ospiti in Rete — Registro richieste posto letto",
    icon: Users,
    items: [
      "Nuovo registro per le richieste di posto letto, integrato direttamente in Affidya",
      "Indicatori principali: Richieste ricevute, Da seguire oggi, Inseriti, Condivisi in rete, Gettoni maturati",
      "Nuova richiesta rapida: obbligatori solo Nome, Cognome, Telefono e consenso privacy; tutti gli altri campi facoltativi",
      "Pannello dettaglio laterale con azioni rapide (Chiama, WhatsApp, Richiedi documenti, Condividi in rete)",
      "Stati semplificati: Nuova, Da seguire, Documenti richiesti, Condiviso in rete, Inserito, Chiuso",
      "Memorandum interno modificabile: Prossima attività, Quando, Assegnato a, Note",
      "Cronologia attività automatica e manuale per ogni richiesta",
      "Richiesta documenti ai familiari: link sicuro con scadenza, notifica di apertura e caricamento, promemoria dopo 3 e 7 giorni",
      "Caricamento documenti da parte delle famiglie tramite link sicuro, senza account",
      "Condivisione in rete: tracciamento stato gettone (In attesa, Maturato, Saldato)",
      "Importazione da email: compilazione automatica dei dati dalla email o dal testo incollato",
      "Anteprima e revisione dei dati importati prima del salvataggio",
    ],
  },
];

const JUNE_2026_TURNI_OSS_SECTIONS = [
  {
    id: "turni-oss-6-ore",
    title: "Turni OSS — schema 6 ore",
    icon: UserCog,
    items: [
      "Nuova modalità di generazione turni Schema 6 ore NNSRLP: 2 notti, smontante, riposo, lunga e pomeriggio",
      "Orari dedicati allo schema 6 ore: mattina 7-13, pomeriggio 13-19, notte 19-7 e lunga 7-19",
      "Pomeriggio corto 14-20 assegnato automaticamente a rotazione giornaliera e visibile come P*",
      "Smontante e riposo salvati nel calendario e visibili anche nell'area OSS",
      "Generazione automatica più equilibrata: i turni vengono distribuiti in base al carico già assegnato a ciascun OSS",
    ],
  },
];

const JUNE_2026_TURNI_AI_SECTIONS = [
  {
    id: "turni-controllo",
    title: "Turni OSS — Controllo e istruzioni aggiuntive",
    icon: ClipboardCheck,
    items: [
      "Nuovo pulsante «Controlla turni» nel calendario: verifica copertura, vincoli, ferie e distribuzione tra gli OSS rispetto alle impostazioni di generazione",
      "Report con errori, avvisi e tabella riepilogativa turni per operatore",
      "Nel dialog di generazione, sezione «Istruzioni aggiuntive» (al posto di «Istruzioni AI») per integrare le regole con testo libero",
      "Interpretazione automatica di ferie/assenze per singolo OSS dalle istruzioni, con completamento buchi tramite generazione standard",
      "Funzione istruzioni aggiuntive abilitabile da admin (Intelligenza Artificiale → Generazione turni assistita)",
    ],
  },
];

const JUNE_2026_ALL_SECTIONS = [
  ...JUNE_2026_TURNI_AI_SECTIONS,
  ...JUNE_2026_TURNI_OSS_SECTIONS,
  ...JUNE_2026_OSPITI_RETE_SECTIONS,
  ...JUNE_2026_SECTIONS,
];

const JULY_2026_SECTIONS = [
  {
    id: "documenti-revisione",
    title: "Documenti: stampe mensili, moduli da firmare e biblioteca",
    icon: FileBox,
    items: [
      "Generazione di Schema Alvo, Schema Docce e registro HACCP più affidabile: i PDF vengono creati come griglie pulite (ospiti × giorni del mese, o una scheda per frigorifero/congelatore), non più basati su modelli precompilati",
      "La stampa dei documenti mensili ora apre il PDF in una nuova scheda e avvia la stampa nativa del browser, evitando le stampe vuote o incomplete",
      "Wizard «Genera mese» per HACCP: al posto della selezione ospiti (non pertinente), mostra le attrezzature configurate e avvisa se manca la configurazione in Impostazioni Stampe",
      "Nuova stampa di default «HACCP Pulizie»: scheda settimanale di esecuzione e verifica pulizia/sanificazione (aree SI/NO, note, firma e firma responsabile HACCP), una pagina per ogni settimana del mese",
      "«Gestisci registri» in Altri Registri: ora è possibile anche eliminare un registro personalizzato",
      "Moduli da Firmare: «Nuovo modulo» e «Modifica» aprono una finestra dedicata con nome e descrizione, al posto della richiesta rapida del browser",
      "Dopo l'invio di un modulo al familiare, il link sicuro al portale è ora visibile e copiabile (anche nello storico invii), utile se l'email non dovesse arrivare",
      "I moduli firmati dai familiari sono ora visibili correttamente nel Fascicolo Assistenziale, sezione Documenti Legali",
      "Documenti Struttura: nuovo filtro «Tutte le categorie» accanto alla ricerca",
      "Biblioteca Affidya: pulsante «Filtri» funzionante con l'elenco delle categorie, e link «Vedi tutti» per Documenti in evidenza e Documenti recenti quando i risultati sono numerosi",
      "Uniformato l'aspetto di tutte le card del modulo Documenti: altezza fissa, testo troncato a 2 righe e azioni sempre allineate in basso",
    ],
  },
  {
    id: "personale-educatore-terapista",
    title: "Personale: educatore, terapista e attività occupazionali",
    icon: UserCog,
    items: [
      "Nuove figure in Operatività → Personale: Educatore e Terapista, con specializzazione obbligatoria (es. educatore professionale, terapista occupazionale, fisioterapista, logopedista)",
      "Stesso calendario turni mensile: per queste figure puoi assegnare AO (attività occupazionale) oppure presenza Mattina/Pomeriggio/Lunga, oltre alle ferie",
      "Nessuna nuova sezione di menu: le attività restano nella griglia esistente; la generazione automatica dei turni resta solo per gli OSS",
      "Accesso Area OSS anche senza email: in Aggiungi OSS puoi scegliere «Codice univoco + password»; Affidya genera il codice (es. ABCD-EFGH) da comunicare all'operatore, che accede da /oss-login con codice e password",
      "Pulizie e Cuoco: puoi inserirli senza email (solo nome e cognome). L'email resta opzionale per l'invio dei turni; non serve un codice univoco perché non hanno un'area riservata",
    ],
  },
  {
    id: "documenti-oss",
    title: "Documenti personali OSS",
    icon: FileText,
    items: [
      "Nuova sezione «I miei documenti» nell'area OSS (/oss/documenti): caricamento semplice di Attestato OSS, Documenti, Corsi, BLSD, HACCP e Certificati",
      "Gli stessi documenti sono visibili in Operatività → Personale sul pulsante Documenti di ogni operatore OSS",
      "La struttura può consultare, scaricare e, se autorizzata, caricare o eliminare i documenti dell'operatore",
    ],
  },
  {
    id: "oss-camere",
    title: "Area OSS — Camere e fascicolo tablet",
    icon: Bed,
    items: [
      "Nuova sezione «Camere» nella dashboard OSS (/oss/camere): card grandi per camera con foto e nome/cognome degli ospiti assegnati",
      "Dal dettaglio camera apri la lista ospiti e, al tap, il fascicolo assistenziale — percorso pensato per tablet",
      "Header del fascicolo OSS più compatto: identità ospite, camera e PDF 118 in una sola barra; schede misurazioni sticky per inserire pressione, glicemia e ossigenazione più facilmente",
    ],
  },
  {
    id: "servizi-anteprima",
    title: "Servizi in anteprima",
    icon: UserSearch,
    items: [
      "Nuova sezione menu «Servizi in anteprima» sotto Dashboard, con Trova Ospiti e Trova Personale (badge BETA)",
      "Trova Ospiti: anteprima del network richieste posto letto, benefici, stato progetto e form per richiedere l'accesso anticipato",
      "Trova Personale: anteprima del matching professionisti socio-sanitari, benefici, stato progetto e form per richiedere l'accesso anticipato",
      "Nel form: richiesta attuale della struttura, provincia/comune e consenso al contatto",
      "In Admin: elenco account abilitati a vedere ogni sezione beta e monitoraggio delle richieste di accesso anticipato",
    ],
  },
  {
    id: "sanitario-rapido",
    title: "Affidya Sanità Rapida",
    icon: HeartPulse,
    items: [
      "Nuovo Modulo Sanitario Rapido per tablet: accesso dedicato da /sanitario-login, separato dal gestionale",
      "Login con email/password, PIN numerico o codice badge (PIN e badge configurabili dalle Impostazioni del modulo)",
      "Dashboard operativa: contesto ospite, pulsante 118, terapie, comunicazioni medici/parenti, scheda sanitaria, collegamento Vera AI",
      "Scheda ospite clinica con allergie, patologie, terapie, documenti e generazione scheda emergenza 118",
      "Link «Sanità Rapida» nella sezione Altre aree di accesso di tutte le pagine di login",
    ],
  },
  {
    id: "assistenza-ticket",
    title: "Assistenza e ticket",
    icon: MessageCircle,
    items: [
      "Dopo l'invio dal widget in sidebar: pulsante «Vedi le richieste» per aprire la pagina Assistenza",
      "Il team Affidya può rispondere ai ticket dall'Admin, anche con una o più foto allegate",
      "Badge in header (e nel menu utente) quando c'è una risposta o un cambio di stato non ancora visto",
      "Notifica push anche alla risposta del team, oltre al cambio di stato del ticket",
    ],
  },
  {
    id: "fatturazione-note-credito",
    title: "Fatturazione — Note di credito e allegati",
    icon: Receipt,
    items: [
      "Nuovo tab «Note di credito» in Contabilità → Fatturazione: elenco dedicato delle NC (TD04)",
      "Azione «Crea nota da fattura»: selezioni una fattura già inviata allo SDI e Affidya duplica le voci come nota di credito, riprendendo note/causale",
      "Numerazione dedicata alle note di credito (prefisso configurabile, default NC), allineata al sezionale Fatture in Cloud",
      "Sync da FIC: importa le note di credito emesse sul provider e le collega alla fattura Affidya di riferimento",
      "Allegati su fattura: upload manuale e import automatico dei PDF fattura farmacia da Deblistering; all'invio SDI vengono caricati su Fatture in Cloud (ZIP se più file)",
      "Preferenze «Fatturazione retta» del fascicolo rispettate anche in Nuova fattura, anteprima e Controllo mensile (esclusa / importo parziale / solo descrizione), non solo in Genera bozze",
      "Nuova fattura e anteprima modelli: nella scelta ospite restano solo i fascicoli attivi (esclusi gli archiviati)",
      "Stato pagamento reale da Fatture in Cloud (TSPay/riconciliazione): colonna Pagamento in Fatture attive, Sync pagamenti FIC, correzione dei falsi «pagata»",
      "Rimosso il tab Configurazione: modelli e aspetto sono nel menu Configurazione (pagine dedicate); pulsante Nuova fattura allineato a destra sulla riga dei tab",
      "Se il destinatario fattura è diverso dall'ospite, nelle note compare automaticamente «Sig./Sig.ra Nome Ospite» (configurabile sul modello)",
      "Collega da FIC (Controllo mensile): ricerca e proposte usano il CF dell'intestatario fascicolo, non quello dell'ospite",
      "In Fatture generate (e SDI / Note di credito): colonna Destinatario mostra «Intestatario (Ospite)» quando i nomi differiscono",
      "Fatture attive/passive: KPI mensili Attive, Passive e Differenza (attive − passive) per controllo ricavi vs costi; filtro mese di default sul mese corrente",
      "Sync stato SDI: se Fatture in Cloud risponde USAGE_LIMIT_REACHED non viene più mostrato il JSON grezzo in Esito; banner giallo sul tab Fatture inviate + toast e stop del batch",
      "Sincronizzazione Fatture in Cloud più affidabile: la pagina legge i dati locali, gli aggiornamenti passano da una coda con rispetto di Retry-After e le fatture con stato SDI definitivo non vengono più interrogate automaticamente",
      "Nuovi webhook Fatture in Cloud nelle Impostazioni: attivazione, verifica e disattivazione delle notifiche automatiche per ridurre il polling",
      "Tab Fatture inviate (SDI): badge «Inviata / in consegna» (allineato a «Inviato» FIC), dettaglio stato FIC, sync ogni 30 minuti",
      "Fatture passive: sync ricalcola lo stato pagamento da FIC (niente falsi «pagata» se amount_due manca) e protegge i pagamenti segnati a mano",
      "Fascicolo ↔ Fatturazione: id fascicolo canonico, stornate non bloccano il mese, Scollega FIC e dettaglio «già collegata» con numero Affidya",
    ],
  },
  {
    id: "crm-lead-strutture",
    title: "CRM Lead e Strutture (CasaDiRiposoPerTe)",
    icon: Users,
    items: [
      "Admin Strutture: filtro Attive / Tutte / Non attive, toggle Attiva, scheda a sezioni (rette corrette da Zoho Retta_c_*, ospiti accettati, servizi, immagini, note)",
      "Azioni scheda struttura: Modifica, Carica immagini, Genera scheda PDF, Storico attività",
      "Lead Trova Ospiti a griglia (ricerca, filtri, ordinamento, colonne configurabili) con dettaglio e proposte illimitate",
      "Matching «Trova strutture compatibili» per comune, raggio km, budget, disponibilità e solo strutture attive",
      "Associazione struttura↔lead con invio schede PDF (struttura / lead / entrambe) e privacy dati sensibili",
      "Acquisizione lead da email inbound Resend + estrazione AI; profilo Operatore CRM (Lead, Strutture, Immobili)",
    ],
  },
  {
    id: "piattaforma-autonoma",
    title: "Piattaforma e amministrazione",
    icon: Shield,
    items: [
      "I dati prima gestiti su CRM esterno (profilo struttura, posti, newsletter, candidati, lead, adesioni gruppi, ospiti in rete/gettoni) sono ora gestiti internamente su Affidya",
      "Nuove sezioni Admin «Contenuti»: Newsletter, Modulistica, Candidati recruiting, Richieste personale, Lead Trova Ospiti (proposte e stati), Gettoni Ospiti in Rete, Adesioni gruppi",
      "Nuova sezione Admin «Manutenzione»: attiva una pagina di manutenzione per gli utenti e invia avviso email prima di un fermo programmato",
      "Profilo struttura e posti disponibili usano l'identificativo nativo Affidya della struttura",
    ],
  },
  {
    id: "deblistering-ricette-molecola",
    title: "Deblistering — Ricette: molecola e anti-duplicati",
    icon: Package,
    items: [
      "Confronto «Farmaci richiesti vs ricette» più preciso: riconosce anche gli equivalenti/generici con lo stesso principio attivo, non solo il nome scritto sul documento",
      "Indicazione «equivalente» nel resoconto pratica e nel dettaglio ricetta quando il farmaco è coperto da un generico",
      "Le richieste farmacia inserite a mano vengono confrontate per molecola grazie a un nuovo riconoscimento IA del principio attivo",
      "Anti-duplicati: una ricetta o richiesta reinviata o inoltrata (stesso allegato o stesse molecole nello stesso mese) non crea più una copia, ma unisce l'allegato a quella già esistente",
      "Rimosso tab Confronto: il confronto farmaci resta in Panoramica → Pratica e nel dettaglio ricetta; Sposta resta dal dettaglio documento",
      "Eliminazione richieste farmacia: dal dettaglio o in blocco sulle selezionate (come le ricette da medico), per cancellare e rifare l'invio",
      "Nel resoconto pratica (Panoramica → Pratica) il confronto farmaci è in due colonne: «Richieste farmacia» e «Ricette ricevute», con indicazione degli equivalenti abbinati",
      "Pulsante «Riconosci equivalenti» nel resoconto: risolve i principi attivi e abbina automaticamente richieste e ricette per molecola/nome",
      "Avanzamento pratica più affidabile: i 5 step si ricalcolano dai documenti reali del ciclo (niente più card a 0/5 con documenti presenti); un solo ciclo aperto per ospite",
      "Riconoscimento equivalenti migliorato: normalizzazione nomi/confezioni/produttori generici, confronto molecole anche con sali diversi, e passata IA sui farmaci ancora spaiati (con cache)",
      "Nel resoconto pratica (Panoramica → Pratica): pulsante «Invia alla farmacia e completa» quando tutti i farmaci richiesti sono in ricetta, e «Sollecita medico» quando ne manca qualcuno",
      "Corretta la classificazione delle email in ingresso senza oggetto/corpo riconoscibile: se il testo non basta, il sistema legge anche il contenuto dell'allegato per distinguere richieste carepy e ricette SSN da vere fatture farmacia",
      "Nuovo pulsante «Riclassifica» in Fatture Farmacia per spostare un documento arrivato per errore (non è una fattura) tra Richieste Farmacia o Ricette da medico, senza perdere l'allegato",
      "Cambio terapia: da Deblistering → Terapie e da Fascicolo → Terapie in corso puoi allegare il documento firmato dal medico o dall'ASL; resta nello storico con download e avvia le proposte da validare",
      "Ricette da medico: con più ricette selezionate puoi anche «Segna come completata» in blocco, oltre a invio farmacia ed elimina",
    ],
  },
  {
    id: "portale-farmacia-carepy",
    title: "Portale Farmacia — Carepy, controllo ricette e solleciti",
    icon: ClipboardCheck,
    items: [
      "Portale Farmacia ampliato: menu Richieste Carepy, Controllo ricette, Clienti diretti e Impostazioni",
      "La farmacia carica i PDF Carepy per gli ospiti aderenti; la struttura li vede in Deblistering → Ricette con badge «Portale farmacia»",
      "Se la struttura abilita l'inoltro in Impostazioni Ricette e ha i medici curanti compilati, la farmacia può inviare le richieste direttamente ai dottori (email a nome struttura)",
      "Cruscotto Controllo ricette: confronto richiesti vs arrivati, farmaci mancanti, selezione multipla e sollecito manuale; solleciti automatici configurabili",
      "Clienti diretti della farmacia: anagrafica, terapie, medici propri, generazione PDF terapie e stesso controllo/solleciti (email a nome farmacia)",
      "Dashboard Portale Farmacia più veloce: KPI e elenco strutture senza pipeline pesante di controllo/IA; caricamento progressivo delle card",
      "Controllo ricette e Scorte più reattivi: una sola risoluzione IA per tutti i farmaci, ricerca senza reload a ogni tasto, dropdown strutture leggero",
      "Le nuove richieste inviate dalla farmacia scadono dopo 30 giorni (prima 7); il valore resta configurabile in Impostazioni farmacia",
      "Portale Farmacia: nuova scheda paziente unica (anagrafica, terapia, scorte, pratiche e documenti), menu retrattile, presa visione immediata e modifica terapia tracciata/notificata alla struttura",
      "Scheda paziente Farmacia completata: scorte e giorni di copertura per gli ospiti, accessi diretti a Carepy e controllo ricette; per i clienti diretti terapie, richieste e ricette sono gestibili dalla stessa scheda",
      "Pratiche è ora l’hub unico per il flusso e la verifica ricette: confronto automatico, verifica farmacia e farmaci non rilevati sono distinti e gli accessi interni portano alla vista corretta",
      "Ricette: la pratica si conclude automaticamente solo quando la farmacia conferma la copertura completa; chiusura, data e operatore sono tracciati e una correzione riapre il ciclo",
      "Carepy: una consegna completa avvia l’attesa mensile per ciascun ospite aderente; il Carepy confermato la soddisfa e un ritardo avvisa farmacia e struttura. Il termine è configurabile nelle Impostazioni farmacia (30 giorni predefiniti)",
      "Strutture: l’amministratore farmacia può collegare una struttura Affidya libera oppure crearne una nuova e invitare il referente all’attivazione",
      "Terapie: nuovi controlli evitano la creazione di terapie attive identiche; disponibile una bonifica tracciata dei duplicati storici",
      "Barra superiore del Portale Farmacia: in Dashboard il saluto e la data; nelle altre pagine titolo, sottotitolo e azioni della sezione al posto della ricerca globale",
      "Scorte: stima dei giorni di copertura dalla posologia e nuovi alert; negli ordini è disponibile la data prevista di consegna. I documenti essenziali possono essere registrati come ricevuti in cartaceo",
      "Impostazioni farmacia: casella inbound per ricette e documenti. Le ricette esterne vengono abbinate dal codice fiscale; i casi non univoci restano in revisione e contratti/privacy vengono archiviati da verificare",
    ],
  },
];

const AUGUST_2026_SECTIONS = [
  {
    id: "manutenzioni-struttura",
    title: "Manutenzioni struttura",
    icon: Wrench,
    items: [
      "Nuovo modulo opzionale Manutenzioni (Operatività → Manutenzioni): richieste di intervento con priorità, stato, categoria e foto",
      "Attivazione in Impostazioni → Struttura per i gestori che vogliono tracciare le spese di manutenzione",
      "Anagrafica fornitori e riepilogo spese mensili (per categoria e fornitore) riservati a Super Admin e Amministrativo",
      "Tutti i ruoli struttura possono aprire richieste; gli OSS con tag «Responsabile» le aprono anche dal portale OSS",
      "In Personale, sullo scheda OSS: switch «Responsabile» per abilitare l'accesso elevato dall'area OSS (anche Manutenzioni se il modulo è attivo)",
    ],
  },
  {
    id: "oss-responsabile-elevato",
    title: "Area OSS — Responsabile",
    icon: Users,
    items: [
      "Il tag Responsabile in Personale abilita poteri elevati in area OSS: gestione e generazione turni di tutti, ordini Risparmio insieme, ordini farmacia (extra blister), anagrafica medici e manutentori, stampe mensili",
      "Switch multi-utente verso un OSS Responsabile: richiede sempre la password; dal Responsabile a un OSS normale senza password",
      "Badge «OSS Responsabile» nell'header quando la sessione attiva è di un responsabile",
      "Nuove sezioni dashboard OSS: Risparmio insieme (/oss/risparmio), Ordini farmacia (/oss/ordini-farmacia), Medici (/oss/medici), Manutentori (/oss/manutentori), Stampe mensili (/oss/stampe-mensili: Alvo, Docce, HACCP, fogli firma e registri)",
      "Ordini farmacia: il Responsabile può inviare ordini extra blister alla farmacia collegata (catalogo, prodotto libero, annulla, risposta sostituzione), come in Deblistering → Ordina prodotti",
    ],
  },
  {
    id: "prima-nota-scontrino-ia",
    title: "Prima Nota — Spesa da scontrino",
    icon: ClipboardCheck,
    items: [
      "In Spese Extra (struttura e area OSS) puoi fotografare o caricare uno scontrino: l'IA propone tipo, importo, data e descrizione",
      "Se sullo scontrino compare il nome ospite, Affidya prova ad abbinarlo all'elenco; verifica sempre i dati prima di salvare",
      "Funzione attivabile in Admin → Intelligenza artificiale («Scontrino spesa»)",
    ],
  },
  {
    id: "oss-alert-terapie-giorno",
    title: "Area OSS — Alert terapie del giorno",
    icon: HeartPulse,
    items: [
      "Dashboard, Fascicoli, Camere e dettaglio camera mostrano badge per somministrazioni di oggi in scadenza o in ritardo (terapie in corso ed extra)",
      "Nel fascicolo ospite i tab Terapie ed Extra riportano il contatore alert; da lì puoi segnare la somministrazione",
      "Notifiche push terapie imminenti (circa 15 minuti prima) sulla PWA tablet: banner al login o menu utente → Attiva avvisi terapie; valgono per il dispositivo/struttura e aprono il fascicolo in area OSS",
    ],
  },
  {
    id: "fascicoli-trasferimento-strutture",
    title: "Fascicoli — Trasferimento tra strutture",
    icon: FolderOpen,
    items: [
      "Sposta ospite in altra struttura (tab Amministrativa): dopo il trasferimento Affidya passa automaticamente alla sede di destinazione",
      "Corretto un caso in cui l'ospite spariva dall'elenco: restava associato a un identificativo legacy e non compariva né in origine né in destinazione",
    ],
  },
  {
    id: "contratti-privacy-struttura",
    title: "Deblistering — Contratti e Privacy",
    icon: Shield,
    items: [
      "Nuova sezione in Deblistering → Impostazioni: Contratti e Privacy Struttura (tra Contatti Farmacia e Template Delega)",
      "Scarica il modello blank della farmacia collegata, firma fuori Affidya e ricarica il firmato (come i PAI)",
      "Archivio condiviso con il Portale Farmacia: entrambi possono caricare o sostituire; alert se mancanti o in scadenza",
      "Nel Portale Farmacia: Impostazioni → Modelli contratto/privacy per caricare i blank destinati alle strutture",
    ],
  },
  {
    id: "deblistering-fatture-vs-richieste",
    title: "Deblistering — Fatture vs Richieste email",
    icon: Package,
    items: [
      "Corretta la classificazione delle email dalla farmacia: una fattura inviata dall'indirizzo farmacia non finisce più tra le Richieste Farmacia",
      "Il sistema legge anche nome file e contenuto dell'allegato (P.IVA, imponibile, …) prima di decidere tra Fatture e Richieste; le fatture deblistering che citano «blister» restano fatture",
      "PDF unico con più fatture (una per ospite): dal Portale Farmacia o via email viene scorporato automaticamente in documenti distinti con ospite, importo e numero fattura",
    ],
  },
];

const SEPTEMBER_2026_SECTIONS = [
  {
    id: "assistente-voce-azioni",
    title: "Assistente virtuale — Chat vocale e operazioni",
    icon: MessageCircle,
    items: [
      "L'assistente può eseguire quasi tutte le operazioni dell'interfaccia con i tuoi permessi; prima di modificare dati mostra una scheda con Conferma e Annulla",
      "Conferma con il pulsante o rispondendo «sì»; la proposta scade dopo 5 minuti e restano escluse gestione utenti, password, pagamenti, firme e file",
      "Nuova chat vocale EVA: parli con l'assistente a voce nel pannello laterale, senza trascrizioni e senza schermo intero (attivabile per singolo utente su richiesta)",
      "EVA si presenta con il proprio nome, pronuncia Affidya come Affidia e non parla di API o di funzioni interne. Controlli: Silenzia, Termina e Torna alla chat scritta",
      "Mentre EVA completa un'operazione in silenzio, un anello animato intorno alla sfera indica che il lavoro è in corso",
      "EVA e la chat vedono le somministrazioni di oggi del fascicolo, comprese quelle in ritardo, chiedendo il nome dell'ospite",
      "EVA non resta più in ascolto dopo aver detto che sta eseguendo un'operazione: compare Sto lavorando… e poi comunica il risultato",
      "L'assistente può registrare pressione, glicemia e saturazione e usare le altre operazioni disponibili nella tua area, sempre con conferma prima di modificare i dati",
    ],
  },
  {
    id: "affidya-family",
    title: "AFFIDYA Family",
    icon: HeartPulse,
    items: [
      "Nuovo portale mobile per familiari e delegati: Home, Percorso PAI, Farmaci, Documenti, Aggiornamenti, Momenti, Richieste e Amministrazione",
      "Account personali e deleghe granulari per ogni ospite: la struttura decide quali dati sono visibili",
      "Ricette e documenti caricabili dalla famiglia con storico delle versioni; nessuna modifica ai dati clinici o alla terapia",
      "Tab Family e menu Gestione → AFFIDYA Family visibili solo agli utenti Affidya con toggle Family abilitato in Admin → Utenti (disabilitato di default)",
      "Tab Family del fascicolo organizzato in sotto-sezioni: Invia invito, Inviti inviati, Momenti e Documenti (richiesta file al familiare, verifica upload e integrazione)",
      "Alla pubblicazione di un Momento i familiari autorizzati ricevono una notifica push sull'app Family",
      "In Altro → Momenti le foto si sfogliano in galleria e un tap le apre a schermo intero",
      "Gestione messaggi Family: tab Messaggi in Gestione → AFFIDYA Family, con contenuto, stati (Nuova, Presa in carico, Risposta inviata, Chiusa) e risposta al familiare",
      "Push alla struttura all'arrivo di una nuova richiesta e push al familiare quando lo stato della richiesta cambia",
      "App Android Family (WebView) per i familiari: all'apertura va su https://www.affidya.app/family-login (produzione, non localhost)",
      "Nell'app Android Family la login non mostra le altre aree Affidya, la barra non copre lo stato del telefono e i link fuori da Family restano bloccati",
      "Notifiche push reali anche nell'app Android Family (oltre alla PWA): banner dopo l'accesso oppure Altro → Profilo e impostazioni",
      "App iOS Family (WebView): all'apertura va su https://www.affidya.app/family-login, come l'app Android",
      "Nell'app iOS Family la login non mostra le altre aree Affidya e i link fuori da Family restano bloccati",
      "Notifiche push anche nell'app iOS Family (Momenti e richieste): banner dopo l'accesso oppure Altro → Profilo e impostazioni",
      "Push al familiare anche per documento richiesto, documento da integrare e documento condiviso dal fascicolo",
      "Nel tab Family del fascicolo i documenti inviati dalla famiglia si aprono con Apri e restano visibili dopo l'accettazione",
      "In Family (browser e app Android) Apri mostra PDF e immagini; i formati non visualizzabili si salvano sul telefono",
      "In Altro → Amministrazione il familiare apre il dettaglio della fattura, visualizza e scarica la copia PDF",
    ],
  },
  {
    id: "operativita-struttura",
    title: "Operatività struttura",
    icon: CalendarDays,
    items: [
      "Promemoria condivisi nella Dashboard: ricorrenze per catetere, prelievi, visite e digiuno, con card di oggi e completamento nell'area OSS",
      "Template turni salvabili e riutilizzabili per ogni struttura",
      "Configurazione massiva di camere e azzeramento guidato delle assegnazioni",
      "Nel fascicolo puoi caricare un file o scattare una foto; su iPad Chrome viene indicato di usare Safari",
      "Controllo costi fornitori: fatture passive per categoria, media a sei mesi e anomalie",
      "Allineamento in blocco della decorrenza fatturazione al primo del mese senza modificare l'ingresso reale",
      "Lista fascicoli: data di ingresso visibile anche in vista a blocchi e ordinamento per ingresso (anche in vista lista)",
      "Fascicoli assistenziali: layout a card colorate, Aggiungi ospite in evidenza e lista a righe separate",
      "Deposito cauzionale opzionale: flag per abilitarlo in fascicolo e creazione rapida contratto (disabilitato di default; se attivo l'importo è obbligatorio)",
      "Stampa documenti del fascicolo: la delega medico firmata è visibile, selezionabile e inclusa nel PDF, senza conteggi extra",
      "Estrazione patologie con AI: legge fino a 6 pagine per PDF, usa diagnosi/terapie/allergie già in cartella come contesto e ha un prompt modificabile in Admin → Intelligenza artificiale",
      "Deblistering → Ricette: dal resoconto pratica puoi inviare le ricette alla farmacia e segnare la pratica come completa; «Pronta invio» compare solo quando tutti i farmaci richiesti sono in ricetta; l'invio automatico al medico parte all'arrivo della richiesta, non solo dopo Analizza IA",
      "Deblistering: le Ricette Bianche Elettroniche (NRBE) si leggono dal testo (AIC e farmaco) e si abbinano all'ospite per codice fiscale anche se il nome sul promemoria è vuoto",
      "Tab Documenti del fascicolo: Pulisci scansione ritaglia lo sfondo delle foto, raddrizza il foglio e migliora contrasto (come Adobe Scan); puoi sostituire l'originale o salvare una copia",
    ],
  },
  {
    id: "ospiti-rete-fascicolo",
    title: "Ospiti in Rete — Conferma ingresso e archivio",
    icon: Users,
    items: [
      "Da una richiesta puoi confermare l'ospite e creare il fascicolo in pre-ingresso o ingresso, con pulsante «Conferma ingresso e crea fascicolo»",
      "I documenti già ricevuti (e quelli caricati in conferma) vengono riconosciuti e catalogati automaticamente nella sezione Documenti del fascicolo",
      "Se è presente la carta d'identità, i dati anagrafici possono essere riconosciuti e compilati nel fascicolo",
      "Le richieste si possono archiviare: tab Archiviate per consultarle e ripristinarle senza perderle",
    ],
  },
  {
    id: "onboarding-inviti",
    title: "Registrazione e onboarding",
    icon: UserCog,
    items: [
      "Se ricevi un invito dal team Affidya, apri il link, completa i dati e scegli piano e pagamento: l'email può includere contratto, brochure e preventivo",
    ],
  },
  {
    id: "alloggiati",
    title: "Alloggiati Web",
    icon: FileText,
    items: [
      "«Correggi dati» resta sul tab Ospiti (niente più schermata vuota dopo un errore di invio)",
      "Cittadinanza: va scelta dall'elenco stati (codice ISTAT). Il testo «ITALIANA» non è più inviato al portale",
      "Il dialog di correzione include il campo Cittadinanza quando il portale la segnala come non valida",
    ],
  },
  {
    id: "fatturazione-set",
    title: "Fatturazione",
    icon: Receipt,
    items: [
      "Nuovo template Fatture in Cloud in Fatturazione → Configurazione → Aspetto fattura: riproduce il modello standard di Fatture in Cloud",
      "Con questo template puoi caricare due loghi separati: quello in alto a sinistra e quello più piccolo in basso a destra, nel piè di pagina",
      "Nel piè di pagina puoi indicare sito web, email, telefono e cellulare; le fatture su più pagine riportano la numerazione «pagina / totale»",
    ],
  },
  {
    id: "consenso-marketing",
    title: "Preferenze comunicazioni",
    icon: Send,
    items: [
      "Nuovo modulo pubblico Richiedi una demo (/richiedi-demo) per contattare il team Affidya prima della registrazione",
      "In Impostazioni → Struttura puoi scegliere se ricevere aggiornamenti Affidya, bandi e contenuti utili all'email amministrativa",
      "Il consenso marketing è facoltativo e può essere revocato in qualsiasi momento senza influire sulle comunicazioni necessarie al servizio",
    ],
  },
  {
    id: "portale-farmacia",
    title: "Portale Farmacia",
    icon: Package,
    items: [
      "La farmacia può invitare una nuova struttura: il referente completa registrazione, piano e pagamento nel normale onboarding Affidya",
      "Dopo l’attivazione, tutte le strutture dell’account multi-struttura vengono collegate automaticamente alla farmacia invitante",
    ],
  },
  {
    id: "commerciale-richieste-famiglie",
    title: "Commerciale — Richieste famiglie",
    icon: Users,
    items: [
      "Richieste famiglie diventa il punto unico per lead CRM, richieste dai siti e pratiche Ospiti in Rete: usa la colonna Origine per riconoscere il canale",
      "I dettagli Ospiti in Rete (gettone, rate, pagamenti e stato pratica) sono disponibili direttamente nel dettaglio del lead per gli operatori autorizzati",
      "Nel matching puoi inviare in un solo passaggio la scheda della struttura alla famiglia e la scheda orientamento alla struttura, dopo aver controllato entrambe le anteprime PDF",
      "Accanto ad Associa e Invia schede vedi i telefoni della struttura e dei referenti, con il nome di chi risponde",
      "Trova strutture compatibili: puoi impostare il budget massimo e un indirizzo o una zona di partenza (via, es. «via tuscolana roma», o quartiere, es. «boccea roma»)",
      "Il raggio in km usa le coordinate Google Maps dell'indirizzo della struttura, non solo il centro del comune",
      "Suggerimenti selezionabili per via/zona e mappa con segnaposto trascinabile per spostare il punto di partenza",
      "Costi Geocoding del matching visibili in Admin → Google Maps API, distinti da Centro Diurno; raggio e cache sono gratuiti",
      "Le richieste da casadiriposoperte.it e casadiriposoperte.app (contatto, form guidato, newsletter) arrivano nella stessa griglia, non in una sezione a parte; le candidature operatori restano in Candidature CasaDiRiposoPerTe",
    ],
  },
  {
    id: "commerciale-notifiche-siti",
    title: "Commerciale — Richieste dai siti",
    icon: Users,
    items: [
      "Push e email all'arrivo di una nuova richiesta da rco-group.it, casadiriposoperte.it e casadiriposoperte.app; i contatti CasaDiRiposoPerTe arrivano in Richieste famiglie e la notifica indica il sito di origine",
      "Le richieste famiglie da casadiriposoperte.it/.app si aprono in Commerciale → Richieste famiglie; R&CO resta in Richieste sito R&CO. e le candidature in Candidature CasaDiRiposoPerTe",
    ],
  },
  {
    id: "commerciale-editor-email",
    title: "Commerciale — Editor Email marketing",
    icon: Mail,
    items: [
      "Nuovo editor grafico per creare campagne email: trascina e riordina titoli, testi, immagini, pulsanti, colonne, social, separatori e spaziatori",
      "Personalizza font, colori, spaziature, layout e anteprima desktop o smartphone; salva i modelli per riutilizzarli nelle campagne successive",
    ],
  },
  {
    id: "interfaccia-layout",
    title: "Interfaccia",
    icon: LayoutDashboard,
    items: [
      "Menu laterale comprimibile nell'area struttura, come in farmacia e amministrazione: pannello centrale e pulsante per ridurre il menu alle icone",
      "Font Plus Jakarta Sans su tutta l'interfaccia",
    ],
  },
];

export const RELEASE_NOTES = [
  {
    id: "2026-10",
    label: "Ottobre 2026",
    sections: OCTOBER_2026_SECTIONS,
  },
  {
    id: "2026-09",
    label: "Settembre 2026",
    sections: SEPTEMBER_2026_SECTIONS,
  },
  {
    id: "2026-08",
    label: "Agosto 2026",
    sections: AUGUST_2026_SECTIONS,
  },
  {
    id: "2026-07",
    label: "Luglio 2026",
    sections: JULY_2026_SECTIONS,
  },
  {
    id: "2026-06",
    label: "Giugno 2026",
    sections: JUNE_2026_ALL_SECTIONS,
  },
  {
    id: "2026-05",
    label: "Maggio 2026",
    sections: MAY_2026_SECTIONS,
  },
];

/** Tab predefinito in pagina novità (ultimo mese pubblicato). */
export const DEFAULT_RELEASE_TAB = CURRENT_RELEASE_MONTH_ID;

/** @deprecated Usare RELEASE_NOTES */
export const RELEASE_SECTIONS = MAY_2026_SECTIONS;

export function getReleaseById(id) {
  return RELEASE_NOTES.find((release) => release.id === id);
}

export function hasSeenReleaseNotes() {
  try {
    const seen = localStorage.getItem(RELEASE_NOTES_SEEN_KEY);
    if (!seen) return false;
    return (
      seen === CURRENT_RELEASE_MONTH_ID ||
      seen.startsWith(`${CURRENT_RELEASE_MONTH_ID}-`)
    );
  } catch {
    return false;
  }
}

export function markReleaseNotesSeen() {
  try {
    localStorage.setItem(RELEASE_NOTES_SEEN_KEY, CURRENT_RELEASE_MONTH_ID);
  } catch {
    /* ignore */
  }
}
